module.exports = __webpack_public_path__ + "img/speaker.865e9887.svg";